import BybSticker from "@Components/common/byb-ds/byb-sticker";
import BybRewardIcon from "@Components/common/byb-ds/icons/byb-reward-icon";
import RewardScarcity from "@Enums/RewardScarcity";
import { BybListItemBackgroundColorGradient, BybRewardColor } from "@Helpers/rewards-mappings";
import { useTheme } from "@mui/material";

interface IBybRewardSticker {
  scarcity: RewardScarcity;
  color?: BybListItemBackgroundColorGradient;
}

export const BybRewardSticker = ({ scarcity, color }: IBybRewardSticker) => {
  const theme = useTheme();

  return (
    <BybSticker
      size="large"
      anchor="none"
      variant="square"
      sx={{
        background: theme.palette.dsPrimaryGradient[color ? color : BybRewardColor[scarcity]],
      }}
    >
      <BybRewardIcon scarcity={scarcity} large />
    </BybSticker>
  );
};
